import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import ResponsiveLayout from '../components/ResponsiveLayout';
import BottomTabBar from '../components/BottomTabBar';
import AppSidebar from './AppSidebar';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../utils/responsive';
import styles from './AppLayout.module.css';

const { Title } = Typography;

const AppLayout: React.FC = () => {
  const { logout, role } = useAuth();
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const handleTabChange = (key: string) => {
    const routeMap: Record<string, string> = {
      dashboard: '/',
      bookings: '/bookings',
      trips: '/trips',
      notifications: '/notifications',
      profile: '/profile',
      'agency-dashboard': '/agency',
      'admin-panel': '/admin',
    };
    const path = routeMap[key];
    if (path) navigate(path);
  };

  const getSelectedTabKey = () => {
    const path = window.location.pathname;
    if (path === '/') return 'dashboard';
    if (path.startsWith('/bookings') || path.startsWith('/reservations')) return 'bookings';
    if (path.startsWith('/trips')) return 'trips';
    if (path.startsWith('/notifications')) return 'notifications';
    if (path.startsWith('/profile')) return 'profile';
    if (path.startsWith('/agency')) return 'agency-dashboard';
    if (path.startsWith('/admin')) return 'admin-panel';
    return 'dashboard';
  };

  if (isMobile) {
    return (
      <div className={styles.mobileContainer}>
        <div className={styles.mobileContent}>
          <Outlet />
        </div>
        <BottomTabBar
          selectedKey={getSelectedTabKey()}
          onTabChange={handleTabChange}
          userRole={role}
        />
      </div>
    );
  }

  return (
    <ResponsiveLayout
      sidebar={<AppSidebar onLogout={handleLogout} />}
      header={
        <Title level={4} style={{ margin: 0 }}>
          پرتو ۳۶۰
        </Title>
      }
    >
      <Outlet />
    </ResponsiveLayout>
  );
};

export default AppLayout;

